import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import Spinner from "../../common/Spinner";
import { MinusIcon } from "@heroicons/react/20/solid";

import { Actions as ASSETACTIONS } from "../../../store/actions/assetActions";

import NotificationManager from "react-notifications/lib/NotificationManager";
import { format } from "date-fns";

const UnassignEmployee = ({
    unassignAsset,
    disabled,
    saving
}) => {
    const { register, handleSubmit, setValue, watch, control, reset } = useForm();

    const onSubmit = (data) => {
        data.dateReturned = format(data.dateReturned, 'yyyy-MM-dd')

        if (!data.dateReturned) {
            NotificationManager.error('Kindly fill all required fields!', 'Unassigning Asset')
            return
        }

        unassignAsset(data);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
                <div className="col-sm-6">
                    <div className="form-material">

                        <Controller
                            as={
                                <DatePicker
                                    dateFormat="dd MMM yyyy"
                                    className="form-control form-input"
                                />
                            }
                            control={control}
                            id="dateReturned"
                            name="dateReturned"
                            defaultValue={new Date()}
                            valueName="selected"
                            onChange={([selected]) => {
                                return selected;
                            }}
                            autoComplete='off'
                        />
                        <label htmlFor="dateReturned">
                            Returned At
                        </label>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
                {!disabled && (
                    <div className="block buttons">
                        <button
                            className="btn btn-danger pull-right"
                            type="submit"
                        >
                            {saving ?
                                <Spinner
                                    style={{ height: "1.5em", float: "left", marginRight: 5, float: 'left' }}
                                    className="animate-spin -ml-1 mr-3 h-5 w-5" />
                                : <MinusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                            }
                            <div style={{ float: "left" }}>Unassign Asset</div>
                        </button>
                    </div>
                )}
            </div>
        </form>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        asset: state.asset.item,
    };
};

const mapDispatchToProps = (dispatch) => ({
    unassignAsset: (input) => dispatch(ASSETACTIONS.unassignAsset(input)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnassignEmployee);
